import { jwtDecode } from 'jwt-decode';

export function isLoggedIn() {
  const token = localStorage.getItem("token")
  // if (!token) return false;
  return (!token) ? false : true

  // const payload = JSON.parse(atob(token.split(".")[1]));
  // return payload.role === "ADMIN";
}

export function isTokenExpired() {
  const token = localStorage.getItem("token");

  if (!token) return false;

  try {
    const decodedToken = jwtDecode(token);
    // JWT exp is in seconds, Date.now() is in milliseconds, so convert both to the same unit (seconds)
    const currentTime = Date.now() / 1000; 
    return decodedToken.exp < currentTime;
  } catch (error) {
    // Handle cases where the token is invalid or cannot be decoded
    console.error('Error decoding token:', error);
    return true; 
  }
}
